module.exports = __webpack_public_path__ + "images/1525d410099cbb190cbeeed9feaad68b.svg";